import {Type} from 'class-transformer';
import {
  Clearance,
  Credential,
  Dependent,
  EmergencyContact,
  EmployeeAccountAssignment,
  EmployeeClass,
  Garnishment,
  PayeeACH,
  PayeeAddress,
  PayeeSettings,
  PayrollPayeeW4Parm,
  QueryResult,
  serializeType,
  EmployeeTermination,
  User,
  W4Deduction
} from "@app/shared";
import {AchCustomer} from "@app/shared/classes/ach-customer";

export class PayeeW4Parms {
  id: number;
  version: number;
  year: number;
  w4Type: string;
  parmName: string;
  parmValue: string;
  payeeId: number;
  jurisdictionParmId: number;
}

export class Payee extends User {
  statusMenu: string;
  name: string;
  address: string;
  email: string;
  phoneNumber: number;
  locationCode: string;
  scaEmployeeClass?: boolean;

  // Payee specific attributes
  hourlySalary: number;
  hoursPerWeek: number;
  disbursementType: string;
  locationName: string;
  employeeClassId: number;
  employeeClassName: string;

  allowWeekendCharging: boolean;
  allowHolidayCharging: boolean;
  type: string;
  employmentType: string;
  disabled: boolean;
  veteran: boolean;
  hasClearance: boolean;
  corpOfficer: boolean;
  signonBonus?: number;
  initialReviewPeriod: number;
  leaveType?: string;
  dateOfVetRelease?: string;
  dateOfLeave?: string;
  dateOfReturn?: string;
  jobRequisitionId?: number;
  positionDescriptionId: number;
  fullName: string;
  lengthOfService: string;
  finalPayrollCheckDate: string;
  //curPayeeSetting: PayeeSettings;

  achCustomerDetails: AchCustomer;
  employeeClass: EmployeeClass;

  @Type(serializeType(PayeeAddress)) addresses?: Array<PayeeAddress>;
  @Type(serializeType(Clearance)) clearances?: Array<Clearance>;
  @Type(serializeType(PayeeACH)) payeeACHs?: Array<PayeeACH>;
  @Type(serializeType(PayeeW4Parms)) payeeW4Parms?: Array<PayrollPayeeW4Parm>;
  @Type(serializeType(PayeeSettings)) payeeSettings?: Array<PayeeSettings>;
  @Type(serializeType(Dependent)) dependents?: Array<Dependent>;
  @Type(serializeType(Credential)) credentials?: Array<Credential>;
  @Type(serializeType(EmergencyContact)) emergencyContacts?: Array<EmergencyContact>;
  @Type(serializeType(EmployeeAccountAssignment)) accountAssignments?: Array<EmployeeAccountAssignment>;
  @Type(serializeType(W4Deduction)) w4Deductions?: Array<W4Deduction>;
  @Type(serializeType(EmployeeTermination)) terminations?: Array<EmployeeTermination>;
  @Type(serializeType(Garnishment)) garnishments?: Array<Garnishment>;
}

//payee details

export class Taxholdings {
  //withholdingAllowance: string;
  //withholdingStatus: string;
  // category: string;
  // subcategory: string;
  // status: string;
  // parameters: string;
  // editable: boolean;
}

export class Earnings {
  code: string;
  description: string;
  rateMultiplier: number;
  effectiveOn: string;
}

export class Deductions {
  deductionType: string;
  healthCoverageType: string;
  description: string;
  premiumCost: number;
  percentageCoverage: number;
}

// organization details

// employee class is not used as this is an upgraded UI
// export class Employeeclass {
//   name: string;
//   description: string;
// }

// employee contacts is now a common component
// export class Employeecontacts {
//   type: string;
//   name: string;
//   title: string;
//   mobile: number;
//   work: string;
//   email: string;
// }

export class Payroll {
  type: string;
  frequency: string;
  checkdate: string;
  status: string;
  startDate: string;
  endDate: string;
}
export class OrgEarnings {
  earningCategory: string;
  earningDescription: string;
  earningHoursamt: string;
}

export class OrgDeductions {
  deduction: string;
  deductionDescription: string;
  deductionMethod: string;
  deductionPreTax: string;
}

export class PtoPolicy {
  employeeclass: string;
  policyname: string;
  effectivedate: string;
}

export class Contacts {
  type: string;
  name: string;
  title: string;
  mobile: number;
  work: number;
  email: string;
  actions: string;
}

export class Tax {
  description: string;
  identification: string;
  depositefrequesncy: string;
  category: string;
  actions: string;
}

export class GeneralClass {
  lName: string;
  dbaLegal: string;
  residentAddressLn2: string;
  bName: string;
  city: string;
  AddressLn2: string;
  selectedState: string;
  selectedCountry: string;
  mPhone: number;
  zip: number;
  fax: number;
  naicscode: string;
  website: string;
  residentAddressLn1: string;
  AddressLn1: string;
}
export class Bank {
  directdeposit: string;
  bankname: string;
  routingnumber: number;
  accountnumber: number;
  employeeaddress: string;

}
export class PayrollSchedule {
  payrollfrequency: string;
  periodperday: string;
}
export class PersonalInfo {
  ssn: number;
  birthDate: string;
  typeMenu: string;
  genderMenu: string;
  firstname: string;
  lastname: string;
  nName: string;
  name: number;
  phone: string;
  address: string;
  mPhone: number;
  city: string;
  wPhone: number;
  selectedState: string;
  email: string;
  accessdocsMethod: string;
  employeeClassMenu: string;
  departmentMenu: string;
  zip: string;
  residentAddressLn2: string;
}


export class PayType {
  payType: string;
  payFrequency: string;
  employementType: string;
  standardhoursperperiod: string;
  state: string;
  classificationcode: string;
  excludedcomp: string;
  statutoryEmployee: string;
}
export class RunPayroll {
  employeename: string;
  // adjustments: string;
  hourlyrate: number;
  salary: number;
  bonus: number;
  misc: string;
  notes: string;
  grossEarnings: string;
  grossDeductions: string;
  grosspay: string;
}

export class RunPayrollEarning {
  earnings: string;
  selectHours: number;
}

export class RunPayrollDeduction {
  deduction: string;
  method: string;
  pretax: string;

}

export class PreviewPayroll {
  employeename: string;
  type: string;
  notes: string;
  totalHours: number;
  grossPay: number;
  deductions: number;
  employeeTaxes: number;
  netPay: number;
  employerTaxes: number;
}
export class PayeeTimesheet {
  employeename: string;
  status: string;
  periodstartdate: string;
  periodenddate: string;
}
export class PayeeTimesheetSummary {
  type: string;
  amount: number;
}
export class PayeeDocument {
  documenttype: string;
  checkdate: string;
  number: number;
  paid: number;
  netpay: number;
}
export class FederalTaxFiling {

  forms: string;
  instructions: string;
}
export class StateTaxFiling {
  city: string;
  forms: string;
  instructions: string;
}
export class LocalTaxFiling {
  forms: string;
  instructions: string;
}
export class PayrollReports {
  reportname: string;
  description: string;
  settings: string;
  download: string;
}
export class ManualCheckEarning {
  name: string;
  selectHours: number;
  selectAmount: number;
}
export class ManualCheckDeduction {
  deduction: string;
  method: string;
  amount: number;
  pretax: string;
}

export class TaxWithholdingManualCheck {
  // federalIncomeTax: number;
  // socialsecurity: number;
  // stateIncomeTax: number;
  // deductions: number;
  taxwithholding: string;
  amount: number;
}

export class SelectPayees {
  select: boolean;
  payeename: string;
}

export enum TaxFormType {
  FEDERAL = 'FEDERAL', STATE = 'STATE', LOCAL = 'LOCAL'
}


export enum AchAllocationType {
  FIXED_DOLLAR_AMOUNT = 'FIXED_DOLLAR_AMOUNT', GROSS_PAY_PERCENT = 'GROSS_PAY_PERCENT', REMAINING_BALANCE = 'REMAINING_BALANCE'
}

export class PayrollTaxForm {
  id: number;
  version: number;
  quarter: number;
  dateFiled: string;
  formPDFId: number;
  instructionPDFId: number;
  formYear: number;
  dueDates: string;
  name: string;
  description: string;
  year: string;
  completedForm: PayrollTaxFiling;
}

export class PayrollTaxFiling {
  id: number;
  version: number;
  taxFormRefId: number;
  taxFormPDFId: number;
  quarter: number;
  dateFiled: number;
  dueDate: number;
}

export class PayrollTaxFormMap {
  taxAgency: string;
  @Type(serializeType(PayrollTaxForm)) taxForms?: Array<PayrollTaxForm>;
}

export class TaxFilingSummary {
  federalFilings: PayrollTaxFormMap;
  @Type(serializeType(PayrollTaxFormMap)) stateFilings?: Array<PayrollTaxFormMap>;
  @Type(serializeType(PayrollTaxFormMap)) localFilings?: Array<PayrollTaxFormMap>;
}

export class PayeeTaxDocument {
  id: number;
  version: number;
  quarter: number;
  checkDate: string;
  payeeFormType: string;
  payeeId: number;
  taxFormPDFId: number;
  taxFormRefId: number;
  formDescription: number;
  formYear: number;
  formName: number;
}

export class PayeeTaxDocumentSearchParam {
  documentType: string;
  year: number;
  checkDate: string;
  payeeId: number;
}


export class PayeeTaxFilingSearchParam {
  year: number;
  quarter: number;
}

export class PayeeTermination {
  payeeId: number;
  dateofTermination: string;
  dateofLastDay: string;
  terminationNotes: string;
  terminationReasonId: number;
}

export class PayrollWageDetermination {
  id?: number;
  version?: number;
  wdNumber: string;
  effectiveOn: string;
  healthAndWelfareRate: number;
  healthAndWelfareRateEO?: number;
  currentHealthAndWelfareRate?: number;
  currentHealthAndWelfareRateEO?: number;

  stateCodeId: number;
  stateName: string;
  employeeClassId: number;
  evenWdNumber: boolean;
  wdCounties: PayrollWDCounty[];
  wdRates: PayrollWDRate[];
  handwRates: PayrollWageDeterminationHealthAndWelfareRate[];

}

export class PayrollWageDeterminationHealthAndWelfareRate {
  id?: number;
  version?: number;
  effectiveFrom: string;
  effectiveThrough: string;
  healthAndWelfareRate: number;
  healthAndWelfareRateEO: number;
  wageDeterminationId: number;
}

export class PayrollScaCategory {
  id: number;
  version: number;
  code: string;
  title: string;
  description: string;
}

export class PayrollWDCounty {
  id: number;
  version: number;
  countyCodeId: number;
  wageDeterminationId: number;
  stateId: number;
  countyName?: string;
  stateName?: string;
}


export class PayrollWDCountyInfo {
  selected?: boolean;
  countyName: string;
  countyCodeId: number;
  stateId: number;
}


export class PayrollWDRate {
  id: number;
  version: number;
  wageRate: number;
  scaOccupationId: number;
  wageDeterminationId: number;
  scaCategoryId: number;
  scaCategoryName?: string;
  scaBaseDescription?: string;
  footNoteReference?:number;
  scaBaseTitle?: string;
  scaBaseId?: number;
  description: string;
  code: string;
  title: string;
}

export class WageDeterminationRateSummary{
  wdRates: PayrollWDRate[];
}

export class PayrollScaOccupation {
  id: number;
  version: number;
  code: string;
  title?: string;
  description?: string;
  scaCategoryId?: number;
  scaBaseId?: number;
  scaCategoryName?: string;
  scaBaseDescription?: string;
  scaBaseName?: string;
}


export class PayrollWDRateBySCACategory {
  scaCategoryId: number;
  scaCategoryName: string;
  wdRates: PayrollWDRate[];
  missingRates?: boolean;
}

export class PayrollWDSearchParam {
  wdNumber: string;
  stateCodeId: number;
  countyCodeId: string;
}

export class WageDeterminationSummary {
  id: number;
  version: number;
  wdNumber: number;
  effectiveOn: string;
  handwRate: number;
  stateCodeId: number;
  contractId: number;
  employeeClassId: number;
  employeeClassName: string;
  stateStr?: string;
  countiesStr: string;
  wdCounties: PayrollWDCounty[];

}


export class PayeeSummary {
  payeeId: number;
  active: boolean;
  flsaType: string;
  setupCompleted: boolean;
  workLocationType: string;
  statusName: string;
  workEmail: string;
  officePhone: string;
  fullName: string;
  @Type(serializeType(PayeeAddress)) address?: PayeeAddress;
}

export class PayeeSummaryObj {
  @Type(serializeType(PayeeSummary)) list: PayeeSummary[];
}

export class PayeeDashboard {
  numberOfEmployees: number;
  federalIncomeTax: number;
  stateIncomeTax: number;
  fica: number;
  medicare: number;
  paidInLastPayroll: number;
  payeeSummary: QueryResult;
}

export class PayrollInsuranceRate {
  id: number;
  version: number;
  effectiveOn: string;
  insuranceRate: number;
  insuranceRateType: string;
  uniqueTaxIdNumber: number;
  description: string;
  taxIDAsString: string;
  txnNumber: string;
}

export class DeductionTypeInstance {
  name: string;
  benefitReferenceCode: string;
  benefitType: string;
  uniqueBenefitID: string;
}

export class PayrollErrorMessage {
  name: string;
  friendlyMessage: string;
}

export class PayrollWarningMessage {
  name: string;
  friendlyMessage: string;
}
